import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../pages/languagecontext";
import ClipLoader from "react-spinners/ClipLoader";
import API from "../pages/Services/Baseservice";
import SEO from "./SEO";

const ContactUs = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const navigate = useNavigate();
  const [firstname, setFirstName] = useState("");
  const [lastname, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const { selectedLanguage } = useContext(LanguageContext);
  const [dropdown, setDropDown] = useState([]);
  const [firstnameerr, setFirstNameErr] = useState("");
  const [lastnameerr, setLastNameErr] = useState("");
  const [emailerr, setEmailErr] = useState("");
  const [messageerr, setMessageErr] = useState("");
  const [selectvalueerr, setSelectValueErr] = useState("");
  const [success, setSuccess] = useState("");
  const [contactusvalues, setContactUsValue] = useState("");
  const [contactus, setContactUs] = useState("");
  const [contactusList, setContactUsList] = useState("");
  const [contactuslinks, setContactUsLinks] = useState("");
  const [webcContactUs, setWebContactUs] = useState("");
  const [loading, setLoading] = useState(true);
  const [conatctUsMap, setContactMap] = useState("");

  const home = () => {
    navigate("/");
  };

  useEffect(() => {
    if (selectedLanguage.id) {
      dropdownlist();
      contactUs();
      setFirstNameErr("");
      setLastNameErr("");
      setEmailErr("");
      setMessageErr("");
      setSelectValueErr("");
      setFirstName("");
      setLastName("");
      setEmail("");
      setMessage("");
      setContactUsValue("");
      setSuccess("");
    }
  }, [selectedLanguage.id]);

  const handleEmail = (e) => {
    setEmailErr("");
    const value = e.target.value;
    setEmail(value);
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) {
      setEmailErr(
        selectedLanguage.id === 1
          ? "Enter a Valid Email Address"
          : "Veuillez entrer une adresse e-mail valide",
      );
      return;
    }
  };

  const Submit = (e) => {
    e.preventDefault();
    setFirstNameErr("");
    setLastNameErr("");
    setEmailErr("");
    setMessageErr("");
    setSelectValueErr("");
    setSuccess("");

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!firstname) {
      setFirstNameErr(
        selectedLanguage.id === 1
          ? "First Name Is Required"
          : "Le prénom est requis",
      );
      return;
    } else if (!lastname) {
      setLastNameErr(
        selectedLanguage.id === 1
          ? "Last Name Is Required"
          : "Le nom de famille est requis",
      );
      return;
    } else if (!email) {
      setEmailErr(
        selectedLanguage.id === 1
          ? "Email Is Required"
          : "L'adresse e-mail est requise",
      );
      return;
    } else if (!emailRegex.test(email)) {
      setEmailErr("Enter a Valid Email Address");
      return;
    } else if (!contactusvalues) {
      setSelectValueErr(
        selectedLanguage.id === 1
          ? "Select service Is Required"
          : "La sélection d'un nom est requise",
      );
      return;
    } else if (!message) {
      setMessageErr(
        selectedLanguage.id === 1
          ? "Message Is Required"
          : "Le message est requis",
      );
      return;
    }

    let req = {
      language_id: selectedLanguage.id,
      first_name: firstname,
      last_name: lastname,
      email: email,
      contactform_id: Number(contactusvalues),
      message: message,
    };

    API.post("webAddContact_Submit/add1", req).then((res) => {
      if (res.data.success === true) {
        setSuccess(res.data.message);
        setFirstName("");
        setLastName("");
        setEmail("");
        setMessage("");
        setContactUsValue("");
        setTimeout(() => {
          setSuccess("");
        }, 3000);
      }
    });
  };

  const dropdownlist = () => {
    setLoading(true);
    let req = {
      language_id: selectedLanguage.id,
    };
    API.post("webcontactservice_list/webCondition", req).then((res) => {
      if (res.data.success === true) {
        setDropDown(res.data.data.data);
        setLoading(false);
      }
    });
  };

  const dropdownclick = (e) => {
    const id = e.target.value;
    setContactUsValue(id);
  };

  const contactUs = () => {
    setLoading(true);
    let req = {
      language_id: selectedLanguage.id,
    };
    API.post("webContact_List/webCondition", req).then((res) => {
      if (res.data.success === true) {
        const data = res.data.data;
        setContactUsList(data);
        setContactUs(data.formFields?.[0] || {});
        setContactMap(data.map?.embed_map_link || "");
        setWebContactUs(data.socialSupport || {});
        setContactUsLinks(data.socialLinks || []);
        setLoading(false);
      }
    });
  };

  const convertToEmbedLink = (url) => {
    if (!url) return "";

    const lang = selectedLanguage.id === 2 ? "fr" : "en";

    if (url.includes("/maps/embed")) {
      return url.includes("hl=")
        ? url
        : `${url}${url.includes("?") ? "&" : "?"}hl=${lang}`;
    }

    const match = url.match(/@(-?\d+\.\d+),(-?\d+\.\d+)/);

    if (match) {
      const lat = match[1];
      const lng = match[2];

      return `https://www.google.com/maps?q=${lat},${lng}&hl=${lang}&output=embed`;
    }

    return "";
  };
  return (
    <div>
       <SEO
                title="Canada work permit consultant | Temporary resident visa Canada services"
                description="Latest updates and expert insights from ASRA Immigration News on Canada visas, policies, and family reunification by a trusted Spousal sponsorship consultant Canada."
                canonical="https://asraimmigration.ca/contactus"
            />
      {loading ? (
        <div
          className="d-flex justify-content-center align-items-center p-5 mt-5"
          style={{ height: "100vh" }}
        >
          <ClipLoader color="#FF050C" size={50} />
        </div>
      ) : (
        <>
          <section className="pb-5 contact-hero d-flex flex-column justify-content-end">
            <div className="container mb-md-5">
              <h1 className="fw-bold">
                {selectedLanguage.id === 1 ? "Contact Us" : "Contactez-nous"}
              </h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a
                      href="#"
                      onClick={(e) => {
                        e.preventDefault();
                        home();
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      {selectedLanguage.id === 1 ? "Home" : "Accueil"}
                    </a>
                  </li>
                  <li className="breadcrumb-item active">
                    {selectedLanguage.id === 1
                      ? "Contact Us"
                      : "Contactez-nous"}
                  </li>
                </ol>
              </nav>
            </div>
          </section>

          <div className="container">
            {contactusList && contactusList?.socialSupport?.title && (
              <section className="socialsupport container">
                <div className="row pt-5 pb-3">
                  <div className="col-lg-12 col-md-10 col-12 mx-auto">
                    <div className="row">
                      <div className="col-lg-10 col-md-10 col-12">
                        <p className="socialsupportp">
                          {webcContactUs ? webcContactUs.title : ""}
                        </p>
                        <h1 className="getintouchh1 fw-bold">
                          {webcContactUs ? webcContactUs.heading : ""}
                        </h1>

                        <div className="row g-3 mt-3">
                          <div className=" col-lg-4 col-12">
                            <div className="trust-card">
                              <div className="trust-icon">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                >
                                  <path d="M12 2 3 7v6c0 5 4 9 9 9s9-4 9-9V7l-9-5z" />
                                  <path d="m9 12 2 2 4-4" />
                                </svg>
                              </div>
                              <h5>Licensed &amp; Regulated</h5>
                              <p>
                                Every consultation is handled by a certified
                                immigration consultant, not a call center.
                              </p>
                            </div>
                          </div>

                          <div className=" col-lg-4 col-12">
                            <div className="trust-card">
                              <div className="trust-icon">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                >
                                  <circle cx="12" cy="12" r="10" />
                                  <polyline points="12 6 12 12 16 14" />
                                </svg>
                              </div>
                              <h5>Fast Response</h5>
                              <p>
                                We typically reply to new enquiries within one
                                business day.
                              </p>
                            </div>
                          </div>

                          <div className=" col-lg-4 col-12">
                            <div className="trust-card">
                              <div className="trust-icon">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="24"
                                  height="24"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  strokeWidth="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                >
                                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                                  <circle cx="9" cy="7" r="4" />
                                  <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                                  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                </svg>
                              </div>
                              <h5>1,000+ Cases Handled</h5>
                              <p>
                                A track record across study permits, work visas,
                                and permanent residency.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-2 col-md-2 col-12 d-flex flex-lg-column justify-content-lg-center justify-content-md-center justify-content-start align-items-lg-end align-items-center mt-3 mt-lg-0">
                        {Array.isArray(contactuslinks) &&
                          contactuslinks.length > 0 &&
                          contactuslinks.map((item, index) => (
                            <img
                              key={item.sslink_id || index}
                              src={item.media?.trim()}
                              alt="social-icon"
                              className="facebook d-flex align-items-center justify-content-center mb-lg-3 mb-2"
                              style={{ cursor: "pointer" }}
                              onClick={() => window.open(item.links, "_blank")}
                            />
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            )}

            <section className="contact-section pt-3 pb-5 container">
              <div className="row">
                <div className="col-lg-12 col-md-10 col-12 mx-auto">
                  <div className="row align-items-center mt-lg-4">
                    <div className="col-lg-6 mb-4 contact-info">
                      {contactusList &&
                        contactusList?.formFields?.length > 0 && (
                          <>
                            <p className="socialsupportp">
                              {contactus ? contactus.title : ""}
                            </p>
                            <h1 className="">
                              {contactus ? contactus.heading : ""}
                            </h1>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: contactus ? contactus.description : "",
                              }}
                            ></div>
                            <p>
                              Address:
                              <br />
                              <strong>
                                {contactus ? contactus.address : ""}
                              </strong>
                            </p>
                            <p>
                              Phone:
                              <br />
                              <strong>
                                {contactus ? contactus.phone_number : ""}
                              </strong>
                            </p>
                            <p>
                              Email:
                              <br />
                              <strong>
                                {contactus ? contactus.email : ""}
                              </strong>
                            </p>
                          </>
                        )}
                    </div>

                    <div className="col-lg-6">
                      <form className="contact-form" onSubmit={Submit}>

                         <p className="socialsupportp mb-4">
                              {contactus ? contactus.title : ""}
                            </p>
                        <div className="row g-3">
                          <div className="col-md-6">
                            <input
                              type="text"
                              className={`form-control ${firstnameerr ? "is-invalid" : ""}`}
                              placeholder={
                                selectedLanguage.id === 1
                                  ? "Enter Your First Name"
                                  : "Entrez votre prénom"
                              }
                              value={firstname}
                              onChange={(e) => {
                                setFirstName(e.target.value);
                                setFirstNameErr("");
                              }}
                            />
                            {firstnameerr && (
                              <div className="invalid-feedback d-block">
                                {firstnameerr}
                              </div>
                            )}
                          </div>

                          <div className="col-md-6">
                            <input
                              type="text"
                              className={`form-control ${lastnameerr ? "is-invalid" : ""}`}
                              placeholder={
                                selectedLanguage.id === 1
                                  ? "Enter Your Last Name"
                                  : "Entrez votre nom de famille"
                              }
                              value={lastname}
                              onChange={(e) => {
                                setLastName(e.target.value);
                                setLastNameErr("");
                              }}
                            />
                            {lastnameerr && (
                              <div className="invalid-feedback d-block">
                                {lastnameerr}
                              </div>
                            )}
                          </div>

                          <div className="col-md-6">
                            <input
                              type="email"
                              className={`form-control ${emailerr ? "is-invalid" : ""}`}
                              placeholder={
                                selectedLanguage.id === 1
                                  ? "Enter email address"
                                  : "Veuillez entrer votre adresse e-mail"
                              }
                              value={email}
                              onChange={handleEmail}
                            />
                            {emailerr && (
                              <div className="invalid-feedback d-block">
                                {emailerr}
                              </div>
                            )}
                          </div>

                          <div className="col-md-6">
                            <select
                              className={`form-select p-2 ${selectvalueerr ? "is-invalid" : ""}`}
                              value={contactusvalues}
                              onChange={dropdownclick}
                            >
                              <option value="">
                                {selectedLanguage.id === 1
                                  ? "Select Service"
                                  : "Sélectionner un service"}
                              </option>
                              {dropdown.length > 0 &&
                                dropdown.map((item, index) => (
                                  <option
                                    key={index}
                                    value={item.contactform_id}
                                  >
                                    {item.label}
                                  </option>
                                ))}
                            </select>
                            {selectvalueerr && (
                              <div className="invalid-feedback d-block">
                                {selectvalueerr}
                              </div>
                            )}
                          </div>

                          <div className="col-12">
                            <textarea
                              className={`form-control ${messageerr ? "is-invalid" : ""}`}
                              rows="4"
                              placeholder={
                                selectedLanguage.id === 1
                                  ? "Enter your message here..."
                                  : "Entrez votre message ici..."
                              }
                              value={message}
                              onChange={(e) => {
                                setMessage(e.target.value);
                                setMessageErr("");
                              }}
                            />
                            {messageerr && (
                              <div className="invalid-feedback d-block">
                                {messageerr}
                              </div>
                            )}
                          </div>

                          {success && (
                            <div className="col-12">
                              <div
                                className="alert alert-success alert-dismissible fade show"
                                role="alert"
                              >
                                {success}
                                <button
                                  type="button"
                                  className="btn-close"
                                  onClick={() => setSuccess("")}
                                ></button>
                              </div>
                            </div>
                          )}

                          <div className="col-12 text-end">
                            <button
                              type="submit"
                              className="btn btn-danger px-4 py-2"
                            >
                              {selectedLanguage.id === 1
                                ? "Submit"
                                : "Soumettre"}
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            {conatctUsMap && (
              <section className="map-section pb-5 mb-5">
                <div class="container">
                  {conatctUsMap && convertToEmbedLink(conatctUsMap) && (
                    <iframe
                      src={convertToEmbedLink(conatctUsMap)}
                      width="100%"
                      height="400"
                      style={{
                        border: 0,
                        borderRadius: "12px",
                        marginTop: "16px",
                      }}
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                      title="Map Preview"
                    />
                  )}
                </div>
              </section>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default ContactUs;
